import type { SVGIconsProps } from "../type";

export function SendIcon({ ...restProps }: SVGIconsProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...restProps}>
        <path d="M21.4999 12.1421L3.07544 20.7943C2.66236 20.9883 2.21879 20.5896 2.38337 20.1722L5.55001 12.1421M21.4999 12.1421L3.07544 3.48998C2.66236 3.296 2.21879 3.69471 2.38337 4.11205L5.55001 12.1421M21.4999 12.1421H5.55001" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
}
